const state = {
  krpDom: null, //krpano dom
};

const mutations = {
  SET_KRP_DOM: (state, dom) => {
    state.krpDom = dom;
  },
};

const actions = {
  //更新krpdom引用
  setKrpDom({ commit }, dom) {
    commit('SET_KRP_DOM', dom);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
